export default __webpack_public_path__ + "static/media/gradient-arrow-narrow-down.dea2f813.svg";